import React, { useState } from 'react';
import './TimeRangeSelector.css';

export const TimeRangeSelector = (props) => {
	const { selected, setSelected } = props;
	const options = ['15m', '1h', '24h', 'all'];

	return (
		<div style={{ border: '1px solid #373844', width: 'min-content' }} className="flex gap-3 bg-[#1A1B1F] p-1 rounded-full">
			{options.map((option) => (
				<button
					key={option}
					onClick={() => setSelected(option)}
					className={`px-4 py-2 rounded-full text-white text-sm font-medium transition-colors ${selected === option ? 'bg-[#2A2B31]' : 'bg-transparent'} ${
						selected === option && 'selected'
					}`}>
					{option}
				</button>
			))}
		</div>
	);
};
